module.exports = require("core-js/library/fn/json/stringify");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/json/stringify.js
// module id = ./node_modules/@babel/runtime/core-js/json/stringify.js
// module chunks = 6 9 11